export default "__VITE_ASSET__e5989f34__"